import React, { useState } from 'react';
import './SuggestionsDropdown.css';

const SuggestionsDropdown = ({ 
  suggestions = [], 
  fieldName, 
  originalValue, 
  onSelect, 
  onCreateRule,
  isVisible = false 
}) => {
  const [selectedValue, setSelectedValue] = useState('');
  const [showRuleDialog, setShowRuleDialog] = useState(false);

  if (!isVisible || !suggestions || suggestions.length === 0) {
    return null;
  }

  const handleSelection = (value) => {
    setSelectedValue(value);
    // Don't call onSelect immediately - wait for user to click Apply Selection
  };

  const handleCreateRule = () => {
    if (selectedValue && onCreateRule) {
      onCreateRule({
        fieldName,
        originalValue,
        selectedValue
      });
    }
    setShowRuleDialog(false);
  };

  const handleApplySelection = () => {
    if (selectedValue) {
      setShowRuleDialog(true);
    }
  };

  return (
    <div className="suggestions-dropdown">
      <div className="suggestions-header">
        <span className="suggestions-icon">🔍</span>
        <strong>{suggestions.length > 1 ? 'Multiple matches' : 'Similar match'} found for "{originalValue}"</strong>
      </div>
      
      <div className="suggestions-content">
        <p>Please select the correct {fieldName === 'projectName' ? 'project' : fieldName === 'jobTitle' ? 'job title' : 'contractor/subcontractor'}:</p>
        
        <div className="suggestions-list">
          {suggestions.map((suggestion, index) => (
            <label key={index} className="suggestion-item">
              <input
                type="radio"
                name={`suggestion-${fieldName}`}
                value={suggestion}
                checked={selectedValue === suggestion}
                onChange={() => handleSelection(suggestion)}
              />
              <span className="suggestion-text">{suggestion}</span>
            </label>
          ))}
        </div>
        
        {selectedValue && (
          <div className="suggestions-actions">
            <button 
              type="button"
              className="btn-apply-suggestion"
              onClick={handleApplySelection}
            >
              Apply Selection
            </button>
          </div>
        )}
      </div>

      {showRuleDialog && (
        <div className="rule-dialog-overlay">
          <div className="rule-dialog">
            <h3>Create Matching Rule</h3>
            <p>
              Would you like to create a rule so that <strong>"{originalValue}"</strong> always 
              maps to <strong>"{selectedValue}"</strong> in the future?
            </p>
            <div className="rule-dialog-actions">
              <button 
                type="button"
                className="btn-create-rule"
                onClick={handleCreateRule}
              >
                Yes, Create Rule
              </button>
              <button 
                type="button"
                className="btn-skip-rule"
                onClick={() => {
                  setShowRuleDialog(false);
                  // Still apply the selection even if no rule is created
                  if (onSelect) {
                    onSelect(selectedValue);
                  }
                }}
              >
                No, Just This Time
              </button>
              <button 
                type="button"
                className="btn-cancel"
                onClick={() => setShowRuleDialog(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SuggestionsDropdown;